(() => {
  const FADE_RANGE = 0.7;
  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const hosts = document.querySelectorAll('[data-grain-wash-host]');
  if (!hosts.length) return;

  if (prefersReducedMotion) {
    hosts.forEach((host) => {
      const wash = host.querySelector('[data-grain-wash]');
      if (wash) wash.style.opacity = '1';
    });
    return;
  }

  const clamp = (n, min, max) => Math.min(max, Math.max(min, n));
  const entries = Array.from(hosts)
    .map((host) => {
      const wash = host.querySelector('[data-grain-wash]');
      return wash ? { host, wash } : null;
    })
    .filter(Boolean);
  if (!entries.length) return;

  let rafId = null;
  const update = () => {
    rafId = null;
    const viewportH = window.innerHeight || document.documentElement.clientHeight || 0;
    const viewportCenter = viewportH / 2;
    const fadeDistance = viewportH * FADE_RANGE;
    entries.forEach(({ host, wash }) => {
      const rect = host.getBoundingClientRect();
      const sectionCenter = rect.top + rect.height / 2;
      const distance = Math.abs(sectionCenter - viewportCenter);
      const opacity = clamp(1 - distance / Math.max(fadeDistance, 1), 0, 1);
      wash.style.opacity = opacity.toFixed(3);
    });
  };

  const schedule = () => {
    if (rafId != null) return;
    rafId = window.requestAnimationFrame(update);
  };

  update();
  window.addEventListener('scroll', schedule, { passive: true });
  window.addEventListener('resize', schedule, { passive: true });
  window.addEventListener('load', schedule, { passive: true });
})();
